import { ApexOptions } from 'apexcharts';

import { CHART_COLORS } from '../shared/chart-colors';

export interface PieChartOptionsConfig {
    labels: string[];
    height: number;
    width?: number;
    colors?: string[];
    type?: 'pie' | 'donut';
    animationsEnabled?: boolean;
    showSliceValues?: boolean;
    expandOnClick?: boolean;
    showLegend?: boolean;
}

const SLICE_VALUE_MIN_ANGLE = 12;

export const getPieChartOptions = (config: PieChartOptionsConfig): ApexOptions => {
    const {
        labels,
        height,
        width,
        colors = [...CHART_COLORS],
        type = 'donut',
        animationsEnabled = true,
        showSliceValues = false,
        expandOnClick = true,
        showLegend = true
    } = config;

    return {
        chart: {
            height,
            width: width || '100%',
            type,
            animations: {
                enabled: animationsEnabled
            }
        },
        dataLabels: showSliceValues
            ? {
                  enabled: true,
                  formatter: (_val, opts) => String(opts.w.config.series[opts.seriesIndex]),
                  dropShadow: {
                      enabled: false
                  },
                  style: {
                      fontSize: '14px',
                      fontWeight: 600,
                      colors: ['#fff']
                  }
              }
            : {
                  enabled: false
              },
        colors,
        labels: labels.map((label) => String(label ?? '').replace(/_/g, ' ')),
        plotOptions: {
            pie: {
                expandOnClick,
                dataLabels: {
                    minAngleToShowLabel: SLICE_VALUE_MIN_ANGLE
                },
                donut: {
                    size: showSliceValues ? '50%' : '65%',
                    labels: {
                        show: false
                    }
                }
            }
        },
        legend: {
            show: showLegend,
            position: 'bottom',
            labels: {
                colors: 'var(--color-foreground-default)'
            }
        },
        stroke: {
            width: 0
        }
    };
};
